import request from '@/utils/request'

// Lấy danh sách
export const getListThongBao = async (id: any, params?: string) => {
  return await request.get(`/v1/notification/search/${id}?${params}`)
}

export const getCountThongBao = async (id: any) => {
  return await request.get(`v1/notification/so-thong-bao/${id}`)
}

// Chi tiết
export const getDetailThongBao = async (id?: string | number) => {
  return await request.get(`/v1/notification/${id}`)
}

// Đọc
export const putReadThongBao = async (id?: string | number) => {
  return await request.put(`/v1/notification/${id}`)
}

// Đọc All
export const putReadThongBaoTatCa = async (id?: string | number) => {
  return await request.put(`/v1/notification/seen-all/${id}`)
}

// Xóa
export const removeThongBao = async (id: number) => {
  return await request.delete(`/v1/notification/${id}`)
}
